module.exports = __webpack_public_path__ + "static/media/appVoala.95eb663b.png";